import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import { MEDIA, COLORS } from '../../utils/styles'
import { ReactComponent as CloseIcon } from '../../statics/images/icon-modal-close.svg'
import SearchWidget from './SearchWidget'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'

const ScModal = styled(Modal)`
  && > div:nth-child(2) {
    outline: 0;
  }
`

const ScWrapper = styled.div`
  position: relative;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 608px;
  ${MEDIA.MOBILE`
    width: 368px;
  `}
`
const ScCloseIcon = styled(CloseIcon)`
  height: 30px;
  width: 30px;
  position: absolute;
  top: -37px;
  right: 7px;
`
const ScCloseText = styled.div`
  position: absolute;
  width: 100%;
  text-align: center;
  font-size: 1rem;
  line-height: 1.69;
  bottom: -34px;
  color: ${COLORS.WHITE};
`
const ScBackdrop = styled(Backdrop)`
  && {
    transition: opacity 299ms cubic-bezier(0, 0, 0.6, 1) 0ms !important;
  }
`

const SearchModal = ({ onClose }) => {
  const [isHidePostPopup, setIsHidePostPopup] = useState(false)

  const closePopup = () => {
    setIsHidePostPopup(true)
    onClose()
  }

  return (
    <ScModal
      open={!isHidePostPopup}
      onClose={closePopup}
      closeAfterTransition
      BackdropComponent={ScBackdrop}
    >
      <ScWrapper>
        <ScCloseIcon onClick={closePopup} />
        <SearchWidget autoFocus={true} isModal={true} closeModalFunc={closePopup} />
        <ScCloseText onClick={closePopup}>Tap to continue reading</ScCloseText>
      </ScWrapper>
    </ScModal>
  )
}

SearchModal.propTypes = {
  onClose: PropTypes.func,
}

SearchModal.defaultProps = {
  onClose: null,
}

export default SearchModal
